import store from '../../vue/store/index';
const wrapper = document.querySelector('.finance__img');
if (wrapper) {
    const img = wrapper.querySelector('svg');
    if (img) {
        function makeActive(item) {
            if (item) {
                item.classList.add('line_active');
                item.classList.remove('line_disabled');

                const number = img.querySelector(`.number[data-id=${item.getAttribute('data-id')}]`);
                if (number) {
                    number.classList.add('number_active');
                }
            }
        }

        function makeDisabled(item) {
            if (item) {
                item.classList.add('line_disabled');
                item.classList.remove('line_active');
                const number = img.querySelector(`.number[data-id=${item.getAttribute('data-id')}]`);
                if (number) {
                    number.classList.remove('number_active');
                }
            }
        }

        function makeClear(item) {
            if (item) {
                item.classList.remove('line_active');
                item.classList.remove('line_disabled');

                const number = img.querySelector(`.number[data-id=${item.getAttribute('data-id')}]`);
                if (number) {
                    number.classList.remove('number_active');
                }
            }
        }

        const lines = img.querySelectorAll('.line');
        lines.forEach((item) => {

            item.addEventListener('mouseover', function () {
                lines.forEach((line) => {
                    makeDisabled(line);
                });
                makeActive(item);
            });

            item.addEventListener('mouseout', function () {
                lines.forEach((line) => {
                    makeClear(line);
                });
            });
        });
    }
}

const financeBtn = document.querySelector('.finance__btn');
if (financeBtn) {
    const financeSection = document.querySelector('.finance__table-section');
    if (financeSection) {
        financeBtn.addEventListener('click', function () {
            if (financeBtn.classList.contains('finance__btn_active')) {
                financeBtn.classList.remove('finance__btn_active');
                financeSection.classList.remove('finance__table-section_active');
                store.dispatch('scrollToElement', {
                    element: document.querySelector('.finance'),
                    duration: 800,
                });
            } else {
                financeBtn.classList.add('finance__btn_active');
                financeSection.classList.add('finance__table-section_active');
                store.dispatch('scrollToElement', {
                    element: financeSection,
                    duration: 600,
                });
            }
        });
    }
}